import React from 'react'
import { connect } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Fieldset } from 'primereact/fieldset'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  InputText,
  SectionTitle,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import useEntradaSIFState from './EntradaSIFState'

function EntradaSIF({ ciclo, dispatch }) {
  const { state, localDispatch } = useEntradaSIFState(ciclo, dispatch)

  if (state.loading) {
    return (
      <div className="p-col-12">
        <SectionTitle>Carregando...</SectionTitle>
      </div>
    )
  }

  if (state.shouldNotRender) {
    return null
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle>010 - Entrada SIF</SectionTitle>
      </div>

      <div className="p-col-12" style={{ marginBottom: 10 }}>
        <strong>Identificadores:</strong>&nbsp;
        {state.identificadores.length ? state.identificadores.join(', ') : '-'}
      </div>

      <Fieldset legend="Associações" collapsed={false} className="p-col-12">
        <div className="p-grid">
          <div className="p-col-12 p-md-4">
            <CustomDropdown
              marginTop={10}
              label="S.I.F"
              optionLabel="label"
              options={state.sifOptions}
              value={state.selectedSif}
              onChange={function (e) {
                localDispatch.setSelectedSif(e)
              }}
              filter
              placeholder="Selecione a SIF"
            />
          </div>

          <div className="p-col-12 p-md-4">
            <CustomDropdown
              marginTop={10}
              label="Ordem de Carregamento"
              optionLabel="label"
              options={state.ocOptions}
              value={state.selectedOc}
              onChange={function (e) {
                localDispatch.setSelectedOc(e)
              }}
              filter
              placeholder="Selecione a OC"
            />
          </div>

          <div className="p-col-12 p-md-4">
            <InputText
              marginTop={10}
              label="DCPOA"
              value={state.dcpoaText}
              onChange={function (v) {
                localDispatch.setDcpoaText(v)
              }}
              placeholder="Digite o DCPOA"
            />
          </div>

          <div className="p-col-12" style={{ marginTop: 10, marginBottom: 10 }}>
            <Btn onClick={localDispatch.associarSif} style={{ marginRight: 10 }}>
              Associar S.I.F
            </Btn>
            <Btn onClick={localDispatch.associarOc} style={{ marginRight: 10 }}>
              Associar OC
            </Btn>
            <Btn onClick={localDispatch.associarDcpoa} style={{ marginRight: 10 }}>
              Associar DCPOA
            </Btn>
          </div>
        </div>
      </Fieldset>

      <div className="p-col-12">
        <div className="p-grid" style={{ marginBottom: 10 }}>
          <div className="p-col-12" style={{ display: 'flex', alignItems: 'center' }}>
            <CustomCheckbox
              checked={state.selecionarTodos}
              onChange={function (checked) {
                localDispatch.toggleSelecionarTodos(checked)
              }}
              style={{ marginRight: '10px' }}
            >
              Selecionar Todos
            </CustomCheckbox>
            <Btn onClick={localDispatch.salvar} style={{ marginLeft: '10px' }}>
              Salvar
            </Btn>
          </div>
        </div>

        <DataTable
          header={
            <CustomDataTableHeader
              onChange={function (v) {
                localDispatch.setGlobalFilter(v)
              }}
            />
          }
          globalFilter={state.globalFilter}
          value={state.itemsFiltrados}
          paginator
          rows={10}
          emptyMessage="Nenhum produto encontrado para este ciclo."
        >
          <Column
            header=""
            style={tableCellCentered(60)}
            body={function (row) {
              return (
                <CustomCheckbox
                  checked={row.selected === true}
                  onChange={function (checked) {
                    localDispatch.toggleSelecionado(row, checked)
                  }}
                />
              )
            }}
          />
          <Column header="Identificador" field="identifier" style={tableCellCentered()} />
          <Column header="Código" field="product_code" style={tableCellCentered()} />
          <Column header="Produto" field="product_name" style={tableCellCentered()} />
          <Column header="Quantidade" field="qte_total" style={tableCellCentered()} />
          <Column header="S.I.F" field="sif_label" style={tableCellCentered()} />
          <Column header="O.C" field="oc_label" style={tableCellCentered()} />
          <Column header="DCPOA" field="dcpoa" style={tableCellCentered()} />
        </DataTable>
      </div>
    </div>
  )
}

export default connect()(EntradaSIF)
